import script from "./CustomActionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomActionCard.vue?vue&type=script&setup=true&lang=js"

import "./CustomActionCard.vue?vue&type=style&index=0&id=50f33857&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f33857"]])

export default __exports__